/* 
useWatchPausable from vueuse (v9.6.0) has bug:
https://vueuse.org/shared/watchpausable/

That's why we have our own custom useWatchPausable()
*/

export function useWatchPausable (watchee, callback) {
	let stop = null;

	const pause = () => {
		stop?.();
		stop = null;
	};
	const resume = () => {
		init();
	};

	const init = () => {
		stop = watch(watchee, callback);
	};

	init();

	return {
		pause,
		resume,
	};
}
